import { localStorageKeys } from 'storageKeys';

export const loadShowComments = () => {
  const recentMethods = localStorage.getItem(localStorageKeys.SHOW_COMMENTS);
  return recentMethods ? JSON.parse(recentMethods) : false;
};

export const saveShowComments = (showComments: boolean) => {
  localStorage.setItem(localStorageKeys.SHOW_COMMENTS, JSON.stringify(showComments));
};
